// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"277":"56da4f29","338":"c5544ec5","508":"a8b8e6da","526":"69bd3577","659":"a8167228","775":"d98934de","888":"a7b6852a"}[chunkId] + ".js";
};